<div [ngClass]="{ 'attention': attention_flg }" class="vital-content">
    <div class="rows">
        <label class="lbl lbl-left" [ngStyle]="cssStyle">{{temperature}}</label>
        <label class="lbl lbl-right" [ngStyle]="cssStyle">{{pulse}}</label>
    </div>
    <div class="rows mg-top-btm">
        <label class="lbl lbl-left" [ngStyle]="cssStyle">{{bp}}</label>
        <label class="lbl lbl-right"[ngStyle]="cssStyle">{{spo2}}</label>
    </div>
</div>